export var ACTION;
(function (ACTION) {
    ACTION["TRIGGER_CTA"] = "TRIGGER_CTA";
    ACTION["TOGGLE_CTA"] = "TOGGLE_CTA";
    ACTION["DISABLE_CTA"] = "DISABLE_CTA";
    ACTION["ENABLE_CTA"] = "ENABLE_CTA";
    ACTION["INPUT_NAME"] = "INPUT_NAME";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["SELECT_QUALIFICATION"] = "SELECT_QUALIFICATION";
    ACTION["STATUS_CHECK"] = "STATUS_CHECK";
    ACTION["STATUS_UNCHECK"] = "STATUS_UNCHECK";
})(ACTION || (ACTION = {}));
export var MARITAL_STATUS;
(function (MARITAL_STATUS) {
    MARITAL_STATUS["SINGLE"] = "SINGLE";
    MARITAL_STATUS["MARRIED"] = "MARRIED";
})(MARITAL_STATUS || (MARITAL_STATUS = {}));
export var EDUCATION;
(function (EDUCATION) {
    EDUCATION["DIPLOMA"] = "DIPLOMA";
    EDUCATION["POST_GRADUATE"] = "POST_GRADUATE";
    EDUCATION["UNDER_GRADUATE"] = "UNDER_GRADUATE";
    EDUCATION["UP_TO_12"] = "UP_TO_12";
    EDUCATION["MBA"] = "MBA";
    EDUCATION["PHD"] = "PHD";
    EDUCATION["PROFESSIONAL"] = "PROFESSIONAL";
    EDUCATION["OTHERS"] = "OTHERS";
})(EDUCATION || (EDUCATION = {}));
export var DETAILS_FOR;
(function (DETAILS_FOR) {
    DETAILS_FOR["SELF"] = "SELF";
    DETAILS_FOR["OTHER"] = "OTHER";
})(DETAILS_FOR || (DETAILS_FOR = {}));
